import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { LOCAL_IMAGES } from '../../../shared/utils/constants';

const AccessFormWrapper = ({ children }) => {
  return (
    <div className="access-form-wrapper">
      <div className="access-form-wrapper-card">
        <img src={LOCAL_IMAGES.LOGO} alt="MiniMe logo" />
        {children}
      </div>
    </div>
  );
};

AccessFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withTranslation('common')(AccessFormWrapper);
